export default class FisheyeSphere extends THREE.Mesh
{
  constructor(fisheye_fov, use_upper_hemisphere, reference_height)
  {
    const geo = new THREE.SphereBufferGeometry(10, 60, 40).toNonIndexed();
    const material = new THREE.MeshBasicMaterial();

    super(geo, material);

    this.reference_height = reference_height || 480;

    this.apply_uv_fisheye_correction(fisheye_fov);
    this.apply_geometry_orientation(use_upper_hemisphere);

    this.material.transparent = true;
    this.material.opacity = 0.5;
  }

  set_texture(map)
  {
    if (this.material.map)
    {
      this.material.map.dispose();
    }
    this.material.map = map;
  }

  apply_uv_fisheye_correction(fisheye_fov)
  {
    const tex_width = this.reference_height;
    const tex_height = this.reference_height;

    const geo = this.geometry;
    geo.scale(-1, 1, 1);
    geo.computeFaceNormals();

    const normals = geo.attributes.normal.array;
    const uvs = geo.attributes.uv.array;

    for (let i = 0, l = normals.length / 3; i < l; i++)
    {
      const x = normals[i * 3 + 0];
      const y = normals[i * 3 + 1];
      const z = normals[i * 3 + 2];

      const correction = (x === 0 && z === 0)
        ? 1
        : (Math.acos(y) / Math.sqrt(x * x + z * z)) * (2 / ((fisheye_fov * Math.PI) / 180));

      uvs[i * 2 + 0] = x * ((tex_height / 2) / tex_width) * correction + ((tex_width / 2) / tex_width);
      uvs[i * 2 + 1] = z * ((tex_height / 2) / tex_height) * correction + ((tex_height / 2) / tex_height);
    }
  }

  apply_geometry_orientation(use_upper_hemisphere)
  {
    const geo = this.geometry;
    if (use_upper_hemisphere === false)
    {
      geo.rotateZ(Math.PI - THREE.Math.degToRad(0));
      geo.rotateX(THREE.Math.degToRad(0));
    }
    else
    {
      geo.rotateZ(THREE.Math.degToRad(0));
      geo.rotateX(-THREE.Math.degToRad(0));
    }
  }

  dispose()
  {
    this.geometry.dispose();
    this.material.dispose();
    if (this.parent)
    {
      this.parent.remove(this);
    }
  }
}
